import { render } from "./InspectorSidebar.vue?vue&type=template&id=4ae5787f&scoped=true"
import script from "./InspectorSidebar.vue?vue&type=script&lang=js"
export * from "./InspectorSidebar.vue?vue&type=script&lang=js"

import "./InspectorSidebar.vue?vue&type=style&index=0&id=4ae5787f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ae5787f"]])

export default __exports__